import { ExpertiseInput, SortBy, SortOrder, ExpertiseFragment } from "@graphql";
import locale from "@bonliva-crm/locale";
import { ObservableQuery } from "@apollo/client";
import { Subscription } from "zen-observable-ts";

export interface ISearchStore {
  queryFuncWatch: ObservableQuery;
  subscription: Subscription;
  unsubscribe: () => void;
}

export const createExpertiseInput = (
  selected: string[],
  expertises: ExpertiseFragment[]
): ExpertiseInput[] => {
  return selected
    .map((x) => {
      const expertise = expertises.find((e) => e.Name === x);
      if (expertise) {
        return [{ name: expertise.Name, exclusive: expertise.Exclusive }];
      }
      return expertises
        .filter((e) => e.Profession === x)
        .map((e) => ({ name: e.Name, exclusive: false }));
    })
    .selectMany((x) => x);
};

export const createExpertiseInputSimple = (
  selected: string[],
  expertises: ExpertiseFragment[]
): string[] => {
  return selected
    .map((x) => {
      // trick e.Name !== "Socionom" is related to search because it has aoe with same name like prof
      const expertise = expertises.find((e) => {
        return (
          (e.Name === x && e.Name !== "Socionom") ||
          (e.Name === "Socionom" && x === "Socionom only")
        );
      });

      if (expertise) {
        return [expertise.Name];
      }
      return expertises.filter((e) => e.Profession === x).map((e) => e.Name);
    })
    .selectMany((x) => x);
};

export const SortOption = {
  name_asc: "name_asc",
  last_contact_asc: "last_contact_asc",
  last_contact_desc: "last_contact_desc",
  oldest_contact_desc: "oldest_contact_desc",
  relevance: "relevance"
} as const;

export type SortOption =
  | "name_asc"
  | "last_contact_asc"
  | "last_contact_desc"
  | "oldest_contact_desc"
  | "relevance"
  | "name_desc";

export const getSortOptions = (active: SortOption) =>
  [
    "name_asc",
    "last_contact_desc",
    "last_contact_asc",
    "oldest_contact_desc",
    "relevance"
  ].map((opt) => ({
    active: active === opt,
    label: locale.sorting[opt],
    value: opt
  }));

export const getSortOptionsNew = () => {
  return Object.values(SortOption).map((opt) => ({
    label: locale.sorting[opt],
    value: opt as SortOption
  }));
};

export function sortOptionToGql(opt: SortOption) {
  if (opt === "last_contact_asc") {
    return {
      sortBy: SortBy.LastContactDate,
      sortOrder: SortOrder.Asc
    };
  } else if (opt === "last_contact_desc") {
    return {
      sortBy: SortBy.LastContactDate,
      sortOrder: SortOrder.Desc
    };
  } else if (opt === "oldest_contact_desc") {
    return {
      sortBy: SortBy.OldestContact,
      sortOrder: SortOrder.Desc
    };
  } else if (opt === "relevance") {
    return {
      sortBy: SortBy.Relevance,
      sortOrder: SortOrder.Desc
    };
  } else {
    return {
      sortBy: SortBy.Name,
      sortOrder: SortOrder.Asc
    };
  }
}
